import { rem } from "polished";
import styled from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

import { CARD_VERTICAL_GAP } from "./constants";

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${({ $viewport }) => $viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `};
`;

export const BoothsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: -${rem(CARD_VERTICAL_GAP)};
`;

export const CenteredHeader = withViewportStyle("div")`
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(24)};
  `}

  .text-primitive.headingTwo {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;
